@if (newsItem) {
    <section class="detail">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-24 col-lg-18">
                    <app-codalt-image
                        [path]="newsItem.id + '/' + newsItem.image"
                        [adapt]="newsItem.adapt_image"
                        [thumb]="newsItem.image_thumb"
                        class="detail__image">
                    </app-codalt-image>
                    <div class="detail__block pb-0 pb-4">
                        <div class="row">
                            <div class="col-24 col-md order-1 order-md-0 mt-md-0 mt-3">
                                <h1 class="detail__title">
                                    {{ newsItem.title }}
                                </h1>
                                <div class="detail__details">
                                    <div class="detail__author">
                                        {{ newsItem.customer_project?.name }} - {{ newsItem.user?.name }}
                                    </div>
                                    <time class="detail__date">
                                        {{ newsItem.publish_date | date: 'EEEE d MMMM yyyy HH:mm' }}
                                    </time>
                                </div>
                            </div>
                            <div class="col-24 col-md-auto order-0 order-md-1 d-flex justify-content-end">
                                <div>
                                    <div class="likes d-flex">
                                        <div
                                            class="like"
                                            [class.active]="ownLike === NewsLikeType.leuk"
                                            (click)="like(NewsLikeType.leuk)"
                                            matTooltip="{{ NewsLikeType.leuk }}">
                                            <i class="fa-solid fa-thumbs-up"></i>&nbsp;&nbsp;{{
                                                (newsItem.likes | where: 'type' : NewsLikeType.leuk)?.length
                                            }}
                                        </div>
                                        <div
                                            class="like"
                                            [class.active]="ownLike === NewsLikeType.nieuwsgierig"
                                            (click)="like(NewsLikeType.nieuwsgierig)"
                                            matTooltip="{{ NewsLikeType.nieuwsgierig }}">
                                            <i class="fa-regular fa-face-smile-halo"></i>&nbsp;&nbsp;{{
                                                (newsItem.likes | where: 'type' : NewsLikeType.nieuwsgierig)?.length
                                            }}
                                        </div>
                                        <div
                                            class="like"
                                            [class.active]="ownLike === NewsLikeType.geweldig"
                                            (click)="like(NewsLikeType.geweldig)"
                                            matTooltip="{{ NewsLikeType.geweldig }}">
                                            <i class="fa-solid fa-heart"></i>&nbsp;&nbsp;{{
                                                (newsItem.likes | where: 'type' : NewsLikeType.geweldig)?.length
                                            }}
                                        </div>
                                        <div
                                            class="like"
                                            [class.active]="ownLike === NewsLikeType.niet_leuk"
                                            (click)="like(NewsLikeType.niet_leuk)"
                                            matTooltip="{{ NewsLikeType.niet_leuk }}">
                                            <i class="fa-solid fa-thumbs-down"></i>&nbsp;&nbsp;{{
                                                (newsItem.likes | where: 'type' : NewsLikeType.niet_leuk)?.length
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <p [innerHTML]="newsItem.content"></p>
                        </div>
                        <div class="item-images">
                            @for (image of newsItem.images; track image.id) {
                                <app-codalt-image
                                    (click)="openImage(image)"
                                    [adapt]="image.adapt_image"
                                    [path]="newsItem.id + '/' + image.path"
                                    [thumb]="image.thumb">
                                </app-codalt-image>
                            }
                        </div>
                        @if (newsItem.documents?.length) {
                            <div class="item-documents">
                                <b>Bijlage(n): </b>
                                <table class="cursor-pointer">
                                    @for (document of newsItem.documents; track document.id) {
                                        <tr (click)="openDocument(document)">
                                            <td>
                                                <i class="fas fa-file-pdf"></i>
                                            </td>
                                            <td>
                                                {{ document.path }}
                                            </td>
                                        </tr>
                                    }
                                </table>
                            </div>
                        }
                        <app-survey-answer [typeObj]="newsItem"></app-survey-answer>
                    </div>
                </div>
                @if (newsItem.readBy) {
                    <div class="col-24 col-lg-6">
                        <div class="detail__block readby">
                            <h3 class="mb-2">Gelezen ({{ newsItem.readBy.length || '0' }})</h3>
                            @for (user of newsItem.readBy; track user.id) {
                                <div>
                                    {{ user.name }}
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
        @if (Functionalities.NewsManagement | hasFunctionality) {
            <div class="floating-buttons">
                <button (click)="delete()" color="primary" mat-fab>
                    <mat-icon class="fas fa-trash"></mat-icon>
                </button>
                <button
                    color="primary"
                    mat-fab
                    routerLink="/{{ Routenames.news }}/{{ newsItem.slug }}/{{ Routenames.survey }}/{{
                        Routenames.answers
                    }}"
                    matTooltip="Poll / vragenlijst voor dit nieuwsbericht">
                    <mat-icon class="fas fa-question"></mat-icon>
                </button>
                <button
                    color="primary"
                    mat-fab
                    routerLink="/{{ Routenames.news }}/{{ newsItem.slug }}/{{ Routenames.copy }}">
                    <mat-icon class="fas fa-copy"></mat-icon>
                </button>
                <button
                    color="primary"
                    mat-fab
                    routerLink="/{{ Routenames.news }}/{{ newsItem.slug }}/{{ Routenames.edit }}">
                    <mat-icon class="fas fa-pencil-alt"></mat-icon>
                </button>
            </div>
        }
    </section>
}
